module.exports = __webpack_public_path__ + "img/1791993369379.27303e24.png";